var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 324,
    viewBox: "0 0 350 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M244.414 19.4895L97.1019 19.8484C96.3068 19.8501 95.5198 20.0085 94.7859 20.3146C94.052 20.6206 93.3856 21.0682 92.8248 21.6319C92.264 22.1956 91.8198 22.8643 91.5175 23.5997C91.2152 24.3352 91.0609 25.123 91.0632 25.9181L91.7322 301.443C91.7339 302.238 91.8923 303.025 92.1984 303.759C92.5044 304.492 92.952 305.159 93.5157 305.72C94.0794 306.28 94.7481 306.725 95.4835 307.027C96.219 307.329 97.0068 307.484 97.8019 307.481L245.114 307.122C245.909 307.121 246.697 306.962 247.431 306.656C248.165 306.349 248.832 305.901 249.393 305.337C249.953 304.773 250.398 304.104 250.7 303.368C251.002 302.632 251.156 301.844 251.153 301.048L250.484 25.5238C250.481 24.729 250.322 23.9425 250.016 23.2091C249.71 22.4758 249.262 21.8099 248.698 21.2496C248.135 20.6892 247.466 20.2454 246.731 19.9434C245.996 19.6414 245.209 19.4872 244.414 19.4895Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.28 23.2512L99.2526 23.6007C95.9151 23.6088 93.2161 26.321 93.2242 29.6585L93.8788 297.553C93.887 300.89 96.5992 303.589 99.9367 303.581L242.964 303.232C246.302 303.224 249.001 300.511 248.992 297.174L248.338 29.2795C248.33 25.942 245.617 23.243 242.28 23.2512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M209.75 30.3485C209.309 33.3182 207.82 36.0321 205.552 37.9994C203.284 39.9666 200.387 41.0575 197.385 41.0746L143.808 41.2031C140.808 41.1977 137.908 40.1199 135.634 38.1643C133.359 36.2087 131.858 33.5042 131.402 30.539L103.025 30.6099C102.252 30.6116 101.486 30.7658 100.771 31.0635C100.057 31.3613 99.4086 31.7968 98.8626 32.3452C98.3167 32.8936 97.8841 33.5441 97.5896 34.2597C97.2951 34.9753 97.1444 35.7419 97.1462 36.5157L97.762 290.677C97.7637 291.451 97.918 292.217 98.216 292.931C98.5141 293.646 98.95 294.295 99.4988 294.841C100.048 295.387 100.699 295.819 101.415 296.114C102.131 296.408 102.898 296.558 103.672 296.556L239.244 296.228C240.017 296.226 240.783 296.072 241.497 295.774C242.212 295.477 242.86 295.041 243.406 294.493C243.952 293.944 244.385 293.294 244.679 292.578C244.974 291.862 245.124 291.096 245.123 290.322L244.507 36.1612C244.505 35.3874 244.351 34.6215 244.053 33.9073C243.756 33.1931 243.32 32.5445 242.772 31.9985C242.223 31.4526 241.573 31.02 240.857 30.7255C240.142 30.431 239.375 30.2803 238.601 30.2821L209.75 30.3485Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.77 33.5698L152.979 34.062C152.49 34.0694 152.099 34.472 152.107 34.9613L152.112 35.3511C152.12 35.8405 152.522 36.2312 153.012 36.2238L185.802 35.7316C186.291 35.7243 186.682 35.3216 186.675 34.8323L186.669 34.4425C186.662 33.9532 186.259 33.5625 185.77 33.5698Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.027 35.6038C194.744 35.593 195.317 35.0032 195.306 34.2863C195.295 33.5695 194.705 32.9971 193.988 33.0079C193.272 33.0186 192.699 33.6085 192.71 34.3253C192.721 35.0422 193.311 35.6146 194.027 35.6038Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.211 223.573C189.213 216.012 187.258 208.578 183.535 201.996C179.813 195.415 174.449 189.909 167.967 186.015C161.485 182.122 154.106 179.973 146.547 179.777C138.988 179.582 131.507 181.347 124.832 184.901C118.158 188.455 112.518 193.676 108.46 200.057C104.403 206.438 102.066 213.76 101.679 221.312C101.291 228.864 102.865 236.387 106.248 243.15C109.63 249.912 114.707 255.684 120.982 259.903L121.008 260.098C122.439 261.468 124.127 262.542 125.975 263.257L126.033 263.062C128.084 264.834 136.719 267.638 146.639 267.612H146.856C153.138 267.612 159.961 266.504 165.96 263.257C165.96 263.257 166.013 263.141 166.093 262.924C167.612 262.21 169.006 261.256 170.222 260.098C170.245 259.929 170.269 259.764 170.293 259.601C176.129 255.578 180.9 250.197 184.196 243.921C187.491 237.645 189.212 230.662 189.211 223.573Z",
    fill: "url(#paint1_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.411 266.061C168.874 266.061 187.895 247.04 187.895 223.578C187.895 200.115 168.874 181.094 145.411 181.094C121.948 181.094 102.928 200.115 102.928 223.578C102.928 247.04 121.948 266.061 145.411 266.061Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.183 241.047C129.183 241.047 119.059 241.875 121.74 260.315C123.126 261.648 124.763 262.693 126.555 263.389L132.249 244.121L129.183 241.047Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.03 241.047C162.03 241.047 172.153 241.875 169.473 260.315C168.087 261.648 166.45 262.693 164.657 263.389L158.964 244.113L162.03 241.047Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.621 210.827C129.621 210.827 124.805 224.845 122.178 223.515C122.178 223.515 147.529 245.415 169.916 223.515C169.916 223.515 165.973 216.507 160.28 210.813L129.621 210.827Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.872 228.345C156.274 228.345 164.706 219.913 164.706 209.511C164.706 199.109 156.274 190.677 145.872 190.677C135.47 190.677 127.038 199.109 127.038 209.511C127.038 219.913 135.47 228.345 145.872 228.345Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.835 241.047H128.992L125.926 254.187C125.926 254.187 124.128 260.27 126.369 262.946C128.611 265.622 149.532 271.705 164.914 263.389C166.256 259.887 166.411 256.041 165.357 252.442C163.585 246.31 164.914 251.999 164.914 251.999L161.835 241.047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M162.274 241.047H129.426L126.36 254.187C126.36 254.187 124.562 260.27 126.804 262.946C129.045 265.622 149.966 271.705 165.348 263.389C166.69 259.887 166.846 256.041 165.791 252.442C164.019 246.31 165.348 251.999 165.348 251.999L162.274 241.047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.03 241.047H129.183L126.117 254.187C126.117 254.187 124.318 260.27 126.56 262.946C128.802 265.622 149.722 271.705 165.105 263.389C166.446 259.887 166.602 256.041 165.548 252.442C163.775 246.31 165.105 251.999 165.105 251.999L162.03 241.047Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M139.257 230.143H152.407V242.859C152.407 243.432 152.294 243.999 152.075 244.529C151.855 245.058 151.534 245.539 151.129 245.945C150.724 246.35 150.243 246.671 149.713 246.891C149.184 247.11 148.616 247.223 148.043 247.223H143.613C142.455 247.223 141.345 246.763 140.527 245.945C139.708 245.126 139.249 244.016 139.249 242.859V230.143H139.257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.257 229.661H152.407V242.376C152.407 242.949 152.294 243.516 152.075 244.046C151.855 244.575 151.534 245.056 151.129 245.462C150.724 245.867 150.243 246.188 149.713 246.408C149.184 246.627 148.616 246.74 148.043 246.74H143.613C142.455 246.74 141.345 246.28 140.527 245.462C139.708 244.643 139.249 243.533 139.249 242.376V229.661H139.257Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M139.284 231.552C143.519 233.135 148.181 233.147 152.425 231.588V229.975H139.284V231.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.872 232.434C156.274 232.434 164.706 224.002 164.706 213.6C164.706 203.199 156.274 194.766 145.872 194.766C135.47 194.766 127.038 203.199 127.038 213.6C127.038 224.002 135.47 232.434 145.872 232.434Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.871 206.445H163.784C163.784 206.445 160.718 191.944 147.144 192.87C133.569 193.796 127.871 206.445 127.871 206.445Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.433 216.081C128.399 216.081 129.183 214.611 129.183 212.798C129.183 210.985 128.399 209.515 127.433 209.515C126.466 209.515 125.683 210.985 125.683 212.798C125.683 214.611 126.466 216.081 127.433 216.081Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.219 216.081C165.185 216.081 165.969 214.611 165.969 212.798C165.969 210.985 165.185 209.515 164.219 209.515C163.252 209.515 162.469 210.985 162.469 212.798C162.469 214.611 163.252 216.081 164.219 216.081Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M127.871 206.932H163.784C163.784 206.932 160.718 192.432 147.144 193.358C133.569 194.283 127.871 206.932 127.871 206.932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M153.71 108.036C153.707 100.475 155.662 93.0412 159.385 86.4596C163.107 79.8779 168.471 74.3722 174.953 70.4784C181.435 66.5847 188.814 64.4356 196.374 64.2403C203.933 64.0451 211.413 65.8103 218.088 69.3642C224.762 72.918 230.403 78.1395 234.46 84.5202C238.518 90.9009 240.854 98.2235 241.242 105.775C241.629 113.327 240.055 120.85 236.672 127.613C233.29 134.375 228.214 140.147 221.938 144.366L221.912 144.561C220.484 145.944 218.796 147.03 216.945 147.755L216.888 147.56C214.836 149.332 206.201 152.137 196.282 152.11H196.065C189.782 152.11 182.959 151.003 176.96 147.755C176.96 147.755 176.907 147.64 176.828 147.423C175.308 146.709 173.914 145.754 172.698 144.596C172.675 144.428 172.651 144.262 172.628 144.1C166.786 140.073 162.012 134.686 158.716 128.404C155.42 122.121 153.702 115.131 153.71 108.036Z",
    fill: "url(#paint2_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.504 150.524C220.967 150.524 239.988 131.504 239.988 108.041C239.988 84.5777 220.967 65.5572 197.504 65.5572C174.041 65.5572 155.021 84.5777 155.021 108.041C155.021 131.504 174.041 150.524 197.504 150.524Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85 124.221C180.85 124.221 170.727 125.049 173.407 143.489C174.794 144.819 176.431 145.861 178.223 146.554L183.916 127.286L180.85 124.221Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.693 124.221C213.693 124.221 223.817 125.049 221.136 143.489C219.749 144.819 218.113 145.861 216.32 146.554L210.627 127.286L213.693 124.221Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.285 94.0006C181.285 94.0006 180.505 96.2689 179.402 98.874C176.991 104.634 179.743 126.657 185.507 129.001C191.975 131.659 200.482 133.325 209.32 130.104C216.998 127.304 219.369 102.192 213.937 96.1006C213.299 95.3828 212.634 94.6695 211.939 93.9784L181.285 94.0006Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.535 111.523C207.937 111.523 216.369 103.091 216.369 92.6891C216.369 82.2875 207.937 73.8553 197.535 73.8553C187.134 73.8553 178.702 82.2875 178.702 92.6891C178.702 103.091 187.134 111.523 197.535 111.523Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M213.503 124.221H180.655L177.59 137.361C177.59 137.361 175.791 143.444 178.033 146.12C180.274 148.796 201.195 154.879 216.577 146.563C217.919 143.061 218.075 139.215 217.02 135.616C215.248 129.484 216.577 135.173 216.577 135.173L213.503 124.221Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M213.937 124.221H181.09L178.024 137.361C178.024 137.361 176.225 143.444 178.467 146.12C180.709 148.796 201.629 154.879 217.012 146.563C218.353 143.061 218.509 139.215 217.455 135.616C215.682 129.484 217.012 135.173 217.012 135.173L213.937 124.221Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.693 124.221H180.85L177.785 137.361C177.785 137.361 175.986 143.444 178.228 146.12C180.469 148.796 201.39 154.879 216.772 146.563C218.114 143.061 218.27 139.215 217.215 135.616C215.443 129.484 216.772 135.173 216.772 135.173L213.693 124.221Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M190.921 113.322H204.061V126.037C204.061 127.194 203.602 128.304 202.783 129.123C201.965 129.941 200.855 130.401 199.697 130.401H195.267C194.11 130.401 193 129.941 192.181 129.123C191.363 128.304 190.903 127.194 190.903 126.037V113.322H190.921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.921 112.834H204.061V125.55C204.061 126.707 203.602 127.817 202.783 128.636C201.965 129.454 200.855 129.914 199.697 129.914H195.267C194.11 129.914 193 129.454 192.181 128.636C191.363 127.817 190.903 126.707 190.903 125.55V112.834H190.921Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M190.952 114.726C195.187 116.309 199.849 116.321 204.092 114.762V113.149H190.952V114.726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.535 115.608C207.937 115.608 216.369 107.176 216.369 96.774C216.369 86.3724 207.937 77.9402 197.535 77.9402C187.134 77.9402 178.702 86.3724 178.702 96.774C178.702 107.176 187.134 115.608 197.535 115.608Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.535 89.6233H215.448C215.448 89.6233 212.382 75.1225 198.807 76.0485C185.232 76.9744 179.535 89.6233 179.535 89.6233Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.096 99.2551C180.062 99.2551 180.846 97.7853 180.846 95.9722C180.846 94.159 180.062 92.6892 179.096 92.6892C178.129 92.6892 177.346 94.159 177.346 95.9722C177.346 97.7853 178.129 99.2551 179.096 99.2551Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.882 99.2551C216.848 99.2551 217.632 97.7853 217.632 95.9722C217.632 94.159 216.848 92.6892 215.882 92.6892C214.915 92.6892 214.132 94.159 214.132 95.9722C214.132 97.7853 214.915 99.2551 215.882 99.2551Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.535 90.1106H215.448C215.448 90.1106 212.382 75.6098 198.807 76.5358C185.232 77.4617 179.535 90.1106 179.535 90.1106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.21521 70.0496V133.281H101.838C101.838 133.281 109.193 147.755 121.837 151.964C121.837 151.964 117.801 141.712 122.014 133.281H149.749V70.0496H2.21521Z",
    fill: "url(#paint3_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.20261 72.2161V132.027H105.887C105.887 132.027 105.887 143.989 117.85 147.977C117.85 147.977 113.862 140.002 117.85 132.027H145.761V72.2161H6.20261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9126 84.1783H18.1648V92.1531H97.9126V84.1783Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.824 96.1404H18.1648V104.115H125.824V96.1404Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.862 108.103H18.1648V116.077H113.862V108.103Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.144 191.887V255.118H241.525C241.525 255.118 234.171 269.592 221.522 273.801C221.522 273.801 225.558 263.549 221.345 255.118H193.61V191.887H341.144Z",
    fill: "url(#paint4_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.156 194.053V253.864H237.471C237.471 253.864 237.471 265.826 225.509 269.814C225.509 269.814 229.497 261.839 225.509 253.864H197.597V194.053H337.156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.738 206.015H213.99V213.99H293.738V206.015Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.65 217.977H213.99V225.952H321.65V217.977Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.687 229.94H213.99V237.914H309.687V229.94Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.5448 316.333H37.2156V323.865H38.5448V316.333Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M41.6461 320.764V319.434H34.1143V320.764H41.6461Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M281.776 85.0644H280.447V92.5961H281.776V85.0644Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M284.877 89.4948V88.1657H277.345V89.4948H284.877Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M310.13 271.143H308.801V278.674H310.13V271.143Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M313.232 275.573V274.244H305.7V275.573H313.232Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226.395 0H225.066V7.53174H226.395V0Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.497 4.43045V3.10132L221.965 3.10132V4.43045H229.497Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.615 315.584C114.253 315.422 113.962 315.131 113.799 314.769C113.636 314.407 113.611 313.997 113.729 313.617C113.748 313.558 113.76 313.497 113.765 313.436C113.776 313.26 113.73 313.086 113.635 312.939C113.539 312.791 113.398 312.679 113.233 312.618C113.068 312.558 112.888 312.552 112.72 312.602C112.551 312.651 112.403 312.754 112.298 312.895C112.263 312.945 112.233 312.998 112.21 313.055C112.047 313.417 111.757 313.708 111.394 313.871C111.032 314.034 110.622 314.059 110.243 313.941C110.184 313.922 110.123 313.91 110.061 313.905C109.886 313.894 109.711 313.94 109.564 314.035C109.417 314.131 109.304 314.272 109.244 314.437C109.183 314.602 109.177 314.782 109.227 314.95C109.277 315.119 109.38 315.267 109.52 315.372C109.57 315.407 109.623 315.437 109.68 315.46C110.043 315.623 110.333 315.913 110.496 316.276C110.659 316.638 110.684 317.048 110.566 317.427C110.547 317.486 110.535 317.547 110.531 317.609C110.519 317.784 110.565 317.959 110.661 318.106C110.756 318.253 110.897 318.366 111.062 318.426C111.227 318.487 111.407 318.493 111.576 318.443C111.744 318.393 111.892 318.29 111.997 318.15C112.033 318.1 112.062 318.047 112.086 317.99C112.248 317.627 112.539 317.337 112.901 317.174C113.263 317.011 113.673 316.986 114.053 317.104C114.112 317.123 114.173 317.135 114.234 317.139C114.41 317.151 114.584 317.105 114.731 317.009C114.879 316.914 114.991 316.773 115.052 316.608C115.112 316.443 115.118 316.263 115.068 316.094C115.019 315.926 114.916 315.778 114.775 315.673C114.725 315.637 114.672 315.608 114.615 315.584Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.6522 174.984C25.2896 174.822 24.9992 174.531 24.8359 174.169C24.6727 173.807 24.6478 173.397 24.7661 173.017C24.7851 172.958 24.797 172.897 24.8016 172.836C24.8129 172.66 24.7673 172.486 24.6715 172.339C24.5757 172.191 24.4349 172.079 24.27 172.018C24.1051 171.958 23.9251 171.952 23.7566 172.002C23.5881 172.051 23.4403 172.154 23.3351 172.295C23.2995 172.345 23.2697 172.398 23.2465 172.455C23.0836 172.817 22.7935 173.108 22.4311 173.271C22.0686 173.434 21.6589 173.459 21.2794 173.341C21.2204 173.322 21.1595 173.31 21.0977 173.305C20.9224 173.294 20.7481 173.34 20.6008 173.435C20.4535 173.531 20.3411 173.672 20.2804 173.837C20.2196 174.002 20.2137 174.182 20.2636 174.35C20.3135 174.519 20.4165 174.667 20.5572 174.772C20.6068 174.807 20.6603 174.837 20.7167 174.86C21.0794 175.023 21.3698 175.313 21.533 175.676C21.6963 176.038 21.7211 176.448 21.6028 176.827C21.5839 176.886 21.572 176.947 21.5674 177.009C21.5488 177.188 21.5897 177.367 21.6836 177.52C21.7776 177.673 21.9193 177.791 22.0869 177.855C22.2546 177.919 22.4386 177.926 22.6106 177.875C22.7826 177.824 22.933 177.717 23.0383 177.572C23.0739 177.522 23.1037 177.469 23.1269 177.412C23.2898 177.05 23.5798 176.759 23.9423 176.596C24.3048 176.433 24.7145 176.408 25.094 176.526C25.1529 176.545 25.2139 176.557 25.2756 176.562C25.451 176.573 25.6253 176.527 25.7726 176.432C25.9198 176.336 26.0322 176.195 26.093 176.03C26.1538 175.865 26.1596 175.685 26.1098 175.517C26.0599 175.348 25.9569 175.2 25.8162 175.095C25.7664 175.052 25.7113 175.014 25.6522 174.984Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.9439 213.529C73.5813 213.366 73.2909 213.076 73.1277 212.714C72.9644 212.351 72.9396 211.942 73.0579 211.562C73.0768 211.503 73.0887 211.442 73.0933 211.38C73.1046 211.205 73.059 211.031 72.9632 210.884C72.8674 210.736 72.7266 210.624 72.5617 210.563C72.3969 210.502 72.2168 210.496 72.0483 210.546C71.8799 210.596 71.732 210.699 71.6268 210.84C71.5912 210.89 71.5615 210.943 71.5382 210.999C71.3753 211.362 71.0852 211.652 70.7228 211.816C70.3603 211.979 69.9506 212.004 69.5711 211.886C69.5122 211.867 69.4512 211.855 69.3895 211.85C69.2141 211.839 69.0398 211.884 68.8925 211.98C68.7453 212.076 68.6329 212.217 68.5721 212.382C68.5113 212.547 68.5055 212.727 68.5553 212.895C68.6052 213.064 68.7082 213.211 68.8489 213.317C68.8985 213.352 68.952 213.382 69.0084 213.405C69.3711 213.568 69.6615 213.858 69.8247 214.221C69.988 214.583 70.0128 214.993 69.8945 215.372C69.8756 215.431 69.8637 215.492 69.8591 215.554C69.8405 215.732 69.8814 215.912 69.9753 216.065C70.0693 216.218 70.2111 216.335 70.3787 216.4C70.5463 216.464 70.7304 216.471 70.9024 216.42C71.0744 216.368 71.2247 216.262 71.33 216.117C71.3656 216.067 71.3954 216.014 71.4186 215.957C71.5815 215.594 71.8716 215.304 72.234 215.141C72.5965 214.978 73.0062 214.953 73.3857 215.071C73.4447 215.09 73.5056 215.102 73.5674 215.106C73.7427 215.118 73.917 215.072 74.0643 214.976C74.2116 214.881 74.324 214.74 74.3847 214.575C74.4455 214.41 74.4514 214.23 74.4015 214.061C74.3516 213.893 74.2486 213.745 74.1079 213.64C74.0581 213.596 74.003 213.559 73.9439 213.529Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.517 318.088C349.154 317.925 348.864 317.635 348.701 317.272C348.538 316.91 348.513 316.5 348.631 316.12C348.65 316.061 348.662 316.001 348.666 315.939C348.678 315.763 348.632 315.589 348.536 315.442C348.441 315.295 348.3 315.182 348.135 315.121C347.97 315.061 347.79 315.055 347.621 315.105C347.453 315.155 347.305 315.258 347.2 315.398C347.164 315.448 347.135 315.501 347.111 315.558C346.948 315.92 346.658 316.211 346.296 316.374C345.933 316.537 345.524 316.562 345.144 316.444C345.085 316.425 345.024 316.413 344.963 316.408C344.787 316.397 344.613 316.443 344.466 316.539C344.318 316.634 344.206 316.775 344.145 316.94C344.084 317.105 344.079 317.285 344.128 317.453C344.178 317.622 344.281 317.77 344.422 317.875C344.472 317.911 344.525 317.94 344.582 317.963C344.944 318.126 345.235 318.416 345.398 318.779C345.561 319.141 345.586 319.551 345.468 319.931C345.449 319.99 345.437 320.051 345.432 320.112C345.414 320.291 345.454 320.47 345.548 320.623C345.642 320.776 345.784 320.894 345.952 320.958C346.119 321.022 346.303 321.029 346.475 320.978C346.647 320.927 346.798 320.82 346.903 320.675C346.939 320.625 346.968 320.572 346.992 320.515C347.155 320.153 347.445 319.862 347.807 319.699C348.17 319.536 348.579 319.511 348.959 319.629C349.018 319.648 349.079 319.66 349.14 319.665C349.316 319.676 349.49 319.63 349.637 319.535C349.785 319.439 349.897 319.298 349.958 319.133C350.019 318.968 350.025 318.788 349.975 318.62C349.925 318.451 349.822 318.303 349.681 318.198C349.631 318.155 349.576 318.117 349.517 318.088Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.65826 294.624C4.12638 294.624 5.31652 293.434 5.31652 291.966C5.31652 290.498 4.12638 289.307 2.65826 289.307C1.19014 289.307 0 290.498 0 291.966C0 293.434 1.19014 294.624 2.65826 294.624Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M302.599 31.0131C304.067 31.0131 305.257 29.8229 305.257 28.3548C305.257 26.8867 304.067 25.6965 302.599 25.6965C301.131 25.6965 299.94 26.8867 299.94 28.3548C299.94 29.8229 301.131 31.0131 302.599 31.0131Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.0765 36.3296C47.5447 36.3296 48.7348 35.1394 48.7348 33.6713C48.7348 32.2032 47.5447 31.0131 46.0765 31.0131C44.6084 31.0131 43.4183 32.2032 43.4183 33.6713C43.4183 35.1394 44.6084 36.3296 46.0765 36.3296Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M305.257 155.951C306.725 155.951 307.915 154.761 307.915 153.293C307.915 151.825 306.725 150.635 305.257 150.635C303.789 150.635 302.599 151.825 302.599 153.293C302.599 154.761 303.789 155.951 305.257 155.951Z",
    fill: "#F55F44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 108.442,
    y1: 312.47,
    x2: 233.778,
    y2: 14.4906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 46805.3,
    y1: 60671,
    x2: 46805.3,
    y2: 43250.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 52484.1,
    y1: 37661.3,
    x2: 52484.1,
    y2: 20233.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 55548.6,
    y1: 35088.4,
    x2: 55548.6,
    y2: 19943.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -487401,
    y1: 57736.7,
    x2: -487401,
    y2: 42591.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 323.865,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.16bcbb53813fef5ec01647ea9e7a6213.svg";
export { ForwardRef as ReactComponent };